<template>
	<div class="p_m_t_30 signal">
		<span class="type_size_20">单题分析</span>
		<div class="p_flex signal_box">
			<div class="p_m_t_30 small_hand" v-for="(item, index) in dataList" :key="index" @click="goDeatil(item.id)">
				<div class="signal_img">
					<img v-if="0 <= item.num && item.num <= 20" src="../../../../assets/img/one.png" />
					<img v-if="21 <= item.num && item.num <= 41" src="../../../../assets/img/three.png" />
					<img v-if="41 <= item.num && item.num <= 60" src="../../../../assets/img/five.png" />
					<img v-if="61 <= item.num && item.num <= 80" src="../../../../assets/img/six.png" />
					<img v-if="81 <= item.num && item.num <= 100" src="../../../../assets/img/eight.png" />
					<div :class="[item.num <= 60 ? '' : 'subject_white']">{{ item.num }}%</div>
				</div>
				<div class="p_m_t_14 signal_name one-overflow" style="text-align: center;">{{ item.name }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props:{
		ids:String
	},
	data() {
		return {
			height: 0,
			dataList: []
		};
	},
	created(){
		this.$request.ajax(this).post("/api_teacher/analysis_report",{
           	job_publish_id: this.ids
		}).then(res=>{
			res.data.questionAnalysis.forEach(item => {
				var nameage={
					name:item.title_pure?item.title_pure:item.title,
					num:item.percentage,
					id:item.id
				}
				this.dataList.push(nameage)
			});
		})
	},
	methods: {
		goDeatil(id) {//作业分析单题分析点击要查看的id
			this.$emit('goSignal', { show: true ,id:id,job_publish_id:this.ids});
		}
	}
};
</script>

<style lang="scss" scoped>
.signal_box {
	flex-wrap: wrap;
}
.signal_box > div {
	width: calc(100% / 5);
}
.signal_img {
	position: relative;
	width: 60px;
	height: 60px;
	margin: 0 auto;
}
.signal_img > div {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
.signal_name {
	padding: 0 10px;
}
.signal {
	padding-bottom: 30px;
}
.signal_img img{
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/analyse/commponents/deatilsignal.vue